import { useState, useCallback } from 'react';
import { apiService } from '../services/api';
import type { AdminOwnerDto } from '../services/api';
import { getApiErrorMessage } from '../types/api-errors';

export const useAdminOwners = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [owners, setOwners] = useState<AdminOwnerDto[]>([]);
    const [totalCount, setTotalCount] = useState(0);

    const fetchOwners = useCallback(async (params?: { search?: string; page?: number; pageSize?: number }) => {
        setLoading(true);
        setError(null);
        try {
            const res = await apiService.getAdminOwners(params);
            setOwners(res.owners);
            setTotalCount(res.totalCount);
            return res;
        } catch (err: unknown) {
            const msg = getApiErrorMessage(err, 'Unable to load owners.');
            setError(msg);
            throw new Error(msg);
        } finally {
            setLoading(false);
        }
    }, []);

    // AB#2112 — explicit target state. The confirmation dialog owns the
    // pending/error UI, so the original error is rethrown (it carries the
    // server's code) and the list-level loading/error state is left alone.
    const toggleStatus = useCallback(
        (ownerId: number, isActive: boolean) => apiService.toggleAdminOwnerStatus(ownerId, isActive),
        [],
    );

    return { loading, error, owners, totalCount, fetchOwners, toggleStatus };
};
